
export const snackBar = (state = {}, action) => {
    var tmpObj = {};

    switch (action.type) {
        case "openSnackBar": tmpObj = { ...state, open: true, mensaje: action.value, autoCloseTime: 2750 };
            return { ...state, ...tmpObj };
        case "openConfirmSnackBar": tmpObj = { ...state, open: true, mensaje: action.value, autoCloseTime: 60000, post: action.post };
            return { ...state, ...tmpObj };
        case "closeSnackBar": tmpObj = { ...state, open: false };
            return { ...state, ...tmpObj };
        case "resetSnackBar":
            return { ...state.snackBar, ...[] };

        default:
            return state;
    }

}